import axios from 'axios'

export default {
  namespaced: true,
  state: {
    open: 0,
    items: [],
    item: {}
  },

  mutations: {
    setOpen (state, value) {
      state.open = value || 0
    },
    setItems (state, value) {
      state.items = value || []
    },
    setItem (state, value) {
      state.item = value || {}
    }
  },

  actions: {
    async loadItems ({ commit }) {
      try {
        let rs = await axios.get('/api/redditiPatrimonio')
        // console.log('/api/redditiPatrimonio', rs.data)
        commit('setItems', rs.data)
      } catch (err) {
        throw err
      }
    },
    async loadItemById ({ commit }, id) {
      try {
        let rs = await axios.get(`/api/redditiPatrimonio/${id}`)
        commit('setItem', rs.data)
      } catch (err) {
        throw err
      }
    },
    async loadLastItem ({ commit }, utente) {
      let rs = null
      try {
        // console.log('loadLastItem ', utente)
        rs = await axios.get(`/api/redditiPatrimonio/lastDoc/${utente}`)
        // console.log('loadLastItem data', rs.data, rs)
        commit('setItem', rs.data)
        return rs.data
      } catch (err) {
        if (err && err.response) {
          if (err.response.data.code === 20005) {
            commit('setItem', null)
            return null
          }
        }
        throw err
      }
    },
    async countOpen ({ commit }) {
      try {
        let rs = await axios.get(`/api/redditiPatrimonio`, { params: { op: 'contaAperte' } })
        commit('setOpen', rs.data.count)
      } catch (err) {
        throw err
      }
    },

    async addNew ({ commit }, { tipoDocumento, codiceUib }) {
      try {
        // console.log('tipoDocumento, codiceUib', tipoDocumento, codiceUib)
        let rs = await axios.post(`/api/redditiPatrimonio`, { tipoDocumento, codiceUib })
        commit('setItem', rs.data)

        // dovrei anche cambiare lo stato alle precedenti dchiarazioni.

        return rs.data
      } catch (err) {
        throw err
      }
    },

    async save ({ commit }, { id, formData }) {
      try {
        // console.log('formData.redditiPatrimonio', id, formData.get('redditiPatrimonio'))
        let rs = await axios({ method: 'put', url: `/api/redditiPatrimonio/${id}`, data: formData, headers: { 'Content-Type': 'multipart/form-data' } })
        commit('setItem', rs.data)
      } catch (err) {
        throw err
      }
    },

    async allegaStandard ({ commit }, { idAllegato, idIstanza }) {
      try {
        // console.log('allegaStandard', idAllegato, idIstanza)
        let rs = await axios.put(`/api/redditiPatrimonio/${idAllegato}/allega`, { idAllegato, idIstanza })
        // console.log('allegaStandard executed', rs)
        commit('setItem', rs.data)
      } catch (err) {
        throw err
      }
    },

    async delete ({ commit }, item) {
      try {
        // console.log('Cancella prospetto redditi e patrimonio', item)
        let rs = await axios.put(`/api/redditiPatrimonio/${item.id}/delete`, item)
        commit('setItem', rs.data)
      } catch (err) {
        throw err
      }
    }

  }
}
